module.exports = __webpack_public_path__ + "static/media/tick.c0cbd084.svg";